import React, { FC } from 'react';
import { Loader } from '../../../components';
import { SwapList } from '../../../components/SwapKiwi/SwapList';
import { useSwaps } from '../../../hooks/apollo/useSwaps';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../constants/routes';
import { SwapStatus } from '../../../types/enums';
import { PageHeader } from '../../../components/SwapKiwi/PageHeader';
import { ReactComponent as CursorKiwiStrike } from '../../../assets/svg/icons/cursor-kiwi-strike.svg';
import { NoDataContainer } from '../../../components/SwapKiwi/NoDataContainer';

export const RecentSwaps: FC = () => {
  const { loading, data } = useSwaps([SwapStatus.CANCELLED, SwapStatus.REJECTED, SwapStatus.EXECUTED], 10);

  const history = useHistory();

  if (loading) {
    return <Loader />;
  }

  if (!loading && (!data || data?.length === 0)) {
    return <NoDataContainer color="grape" message1="Nothing to see here yet." hasCta description="" />;
  }

  const onSwapClick = (id: string): void => {
    history.push(Routes.RECENT_SWAP_DETAILS.replace(':id', id));
  };

  return (
    <section>
      <PageHeader
        background="grape-400"
        notTopBorder={false}
        title="Recent Swaps"
        description='<p class="text-lg text-cloud-900">This page displays all the swaps you have had on this platform. <br />Your wallet is always on the left, and the swap card displays the assets each part proposed to trade.</p>'
        link={{ label: 'Learn More', url: '/faq' }}
        sticker={CursorKiwiStrike}
        stickerWidth={264}
        breadcrumbs={{
          links: [
            {
              label: 'Home',
              slug: Routes.LANDING_ROUTE,
            },
            {
              label: 'Recent Swaps',
              slug: Routes.RECENT_SWAPS,
            },
          ],
        }}
      />
      <SwapList swapList={data} onSwapClick={onSwapClick} />
    </section>
  );
};
